module.exports = "<h2>\n  <span class=\"point no-margin\" [ngStyle]=\"{background: color}\"></span>\n\n  Rain Diverter\n</h2>\n\n<ul class=\"feature oneline\">\n  <li *ngFor=\"let key of objectKeys(rainDiverters)\">\n    <park-rain-diverter-item [rainDiverter]=\"rainDiverters[key]\" [rainDiverterId]=\"key\" [parkId]=\"parkId\" [id]=\"id\"></park-rain-diverter-item>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/controls/others/rain_diverter/park-rain-diverter-controls.html
// module id = ./src/app/dashboard/parks/park/controls/others/rain_diverter/park-rain-diverter-controls.html
// module chunks = main